import { render, staticRenderFns } from "./WebhookRequest.vue?vue&type=template&id=18136b30"
import script from "./WebhookRequest.vue?vue&type=script&lang=js"
export * from "./WebhookRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports